<template>
  <div class="flex-none px-3 pt-6 text-sm font-semibold text-gray-400 xl:pt-0">
    <div
      v-if="typeof intensity === 'number'"
      class="flex items-center"
    >
      <h4 class="text-3xl font-semibold text-slate-900 no-localize-translate">
        {{ emissionsIntensity }}
      </h4>
      <span class="ml-2 text-sm">tCO2e per {{ companyCurrency }}</span>
    </div>
    <div
      v-else
      class="flex items-center"
    >
      <h1 class="text-xl text-slate-900 md:text-3xl 2xl:text-5xl no-localize-translate">
        {{ Math.floor(Math.random() * 100) }}
      </h1>
      <span class="ml-2">tCO2e per USD</span>
    </div>
    <div class="mt-0.5 whitespace-nowrap">
      Emissions Intensity
    </div>
    <div
      v-show="typeof intensity === 'string'"
      class="absolute inset-0 z-10 flex items-center justify-center bg-gray-100 opacity-90"
    >
      <div class="mt-0.5 px-1 text-center text-slate-600">
        Please update revenue information to view this metric
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmissionIntensityCard',

  props: {
    intensity: {
      type: [Number, String],
      default: null,
    },
    currency: {
      type: String,
      required: true,
    },
  },

  computed: {
    emissionsIntensity() {
      return typeof this.intensity === 'number'
        ? this.intensity.toFixed(2)
        : this.intensity
    },
    companyCurrency() {
      return this.currency
    },
  },
}
</script>
